const Director = 'Director'

export default [
  {
    path: '/settings/payment_reminder',
    name: 'PaymentReminderSettings',
    redirect: { name: 'WhatsappMessages' },
  },
]

